import { Checkbox } from './ui/Checkbox';
import { getShipmentStatusClasses } from '../utils/status';
import { getPickupDisplayName } from '../utils/format';


export const OrderCard = ({
  order,
  onSelect,
  onTrackingClick,
  selectable = false,
  isSelected = false,
  onSelectChange,
}: {
  order: any;
  onSelect: (order: any) => void;
  onTrackingClick?: (order: any) => void;
  selectable?: boolean;
  isSelected?: boolean;
  onSelectChange?: (checked: boolean) => void;
}) => {
  return (
    <div
      onClick={() => onSelect(order)}
      className={`relative bg-white rounded-2xl shadow border pt-4 hover:shadow-md transition cursor-pointer overflow-hidden flex flex-col h-full ${isSelected ? 'border-2 border-teal bg-teal/5' : ''}`}
    >
      {/* Selection Checkbox */}
      {selectable && (
        <div
          className="absolute top-4 right-4 z-10"
          onClick={(e) => e.stopPropagation()}
        >
          <Checkbox
            checked={isSelected}
            onChange={(e) => onSelectChange?.(e.target.checked)}
          />
        </div>
      )}

      {/* Pickup & Delivery */}
      <div className="flex flex-col gap-0 items-start justify-bewteen">
        <div
          className={`ml-4 mb-2 w-fit h-fit text-[10px] px-2 py-0.5 border rounded-lg font-bold ${getShipmentStatusClasses(order.shipment_status)}`}
        >
          {order.shipment_status || 'PENDING'}
        </div>
        <div className={`px-3 flex items-center gap-3 mb-3`}>
          <div className="flex flex-col items-center">
            <div className="w-2.5 h-2.5 bg-teal rounded-full" />
            <div className="w-0.5 h-10 border-l-2 border-dotted border-gray-300" />
            <div className="w-2.5 h-2.5 bg-gray-400 rounded-full" />
          </div>

          <div className="xl:text-xs 2xl:text-sm text-gray-700 ">
            <div>
              <p className="font-bold text-[10px] text-teal ">
                Pickup ( {getPickupDisplayName(order.origin_address)} )
              </p>
              <p className="truncate">
                {order.origin_address?.pincode}, {order.origin_address?.city},{' '}
                {order.origin_address?.state}
              </p>
            </div>
            <div className="mt-2">
              <p className="font-bold text-[10px] text-gray-500 ">
                Delivery ({' '}
                {order.destination_address?.contact_name || 'Customer'} )
              </p>
              <p className="truncate ">
                {order.destination_address?.pincode},{' '}
                {order.destination_address?.city},{' '}
                {order.destination_address?.state}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Weight + Amount */}
      <div className="flex px-4 justify-between text-sm font-medium mb-3 mt-auto">
        <div className="flex flex-col items-center justify-center ">
          <span>{order.dead_weight || 0} Kg</span>
          <span className="text-text3 text-xs">Chargeable Weight</span>
        </div>
        <div className="flex flex-col items-center justify-center ">
          <span className="text-teal font-bold">₹{order.shipment_value}</span>
          <span className="text-text3 text-xs">Chargeable Amount</span>
        </div>
      </div>

      {/* AWB + Date */}
      <div
        className="px-4 mt-auto bg-teal py-2 text-sm flex justify-between items-center"
        onClick={(e) => {
          if (onTrackingClick) {
            e.stopPropagation();
            onTrackingClick(order);
          }
        }}
      >
        <span className="font-bold text-white hover:underline">
          {order.awb_number || 'No AWB'}
        </span>
        <span className="text-gray-100">
          {new Date(order.created_at).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
};
